import React from "react";
import LeftImage from "../../assets/icons/player 1.svg";
import RightImage from "../../assets/icons/BASK.svg";
import mocion from "../../assets/icons/logoIcon.svg";
import authLayoutimage from "../../assets/images/authLayout.png";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

interface LayoutProps {
  children: React.ReactNode;
  width?: string;
  padding?: string;
  height?: string;
}

const AuthLayout: React.FC<LayoutProps> = ({
  children,
  width,
  padding,
  height,
}) => {
  const { Auth }: DictionaryType = useGetDictionary();
  return (
    <div className="flex items-center justify-center h-dvh relative">
      {/* Background Image */}
      <img loading="lazy"
        src={authLayoutimage}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />

      {/* Left Image */}
      <img loading="lazy"
        src={LeftImage}
        alt="Left"
        className="absolute bottom-0 left-3.5 hidden lg:block lg:w-[300px]"
      />

      {/* Right Image */}
      <img loading="lazy"
        src={RightImage}
        alt="Right"
        className="absolute bottom-0 right-0 hidden lg:block  lg:w-[200px]"
      />

      {/* Footer */}
      <div className="absolute bottom-5 flex items-center text-white">
        <p className="text-[18px] font-light text-center mr-2 text-primary dark:text-white">
          {Auth?.all_rights_reserved_to}
        </p>
        <img loading="lazy" src={mocion} alt="Mocion Logo" className="h-[51px]" />
      </div>

      {/* Card */}
      <div
        className={`relative z-10 bg-white text-primary dark:text-white ${
          width ? width : "w-[800px]"
        } ${height ? height : "max-h-[550px]"} rounded-2xl shadow-lg mx-5 ${
          padding ? padding : "px-8"
        }  py-10 overflow-y-auto  customScroll`}
      >
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
